import { Component } from '@angular/core';
import { GoogleSigninComponent } from './app-google.sigin/google-signin-component';

@Component({
  selector: 'app-google-signin-wrapper',
  templateUrl: './app-google-signin.html',

  imports: [GoogleSigninComponent],
})
export class AppGoogleSigninComponent {
  googleSignin(googleWrapper: any) {
    googleWrapper.click();
  }
}
